// Code generated by tygo. DO NOT EDIT.

//////////
// source: audit.go

export type AuditType = number /* int */;
export const NoAudit: AuditType = 0;
export const BasicAudit: AuditType = 1;
export const InternalAudit: AuditType = 2;
export const ForeignInternalAudit: AuditType = 3;
/**
 * enum for AuditCommentKind
 */
export type AuditCommentKind = string;
export const Ok: AuditCommentKind = "ok";
export const Remark: AuditCommentKind = "remark";
export const Defect: AuditCommentKind = "defect";
export const NoKind: AuditCommentKind = "noKind";
export const InAudit: AuditCommentKind = "inAudit";

//////////
// source: bp.go

export type TableType = string;
export const TypeAsset: TableType = "asset";
export const TypeDataAsset: TableType = "data-asset";

//////////
// source: custom_field.go

export type CustomFieldType = string;
export const CF_Text: CustomFieldType = "text";
export const CF_Select: CustomFieldType = "select";
export const CF_Checkbox = "checkbox";
export const CF_Calendar = "calendar";
export const CF_User = "user";
export const CF_URL: CustomFieldType = "URL";

//////////
// source: due_date_status.go

export type DueDateStatus = string;
export const DueDateOnTime: DueDateStatus = "ontime";
export const DueDateApproaching: DueDateStatus = "approaching";
export const DueDateCritical: DueDateStatus = "critical";
export const DueDateOverdue: DueDateStatus = "overdue";
export const MissingStr: DueDateStatus = "missing";
export const UpdatedAtStr: DueDateStatus = "updated_at";
export const DueDateStr: DueDateStatus = "due_date";
export const Older: DueDateStatus = "older";

//////////
// source: filter.go

export type SpecialMethodFilter = string;
export const SMF_NoComment: SpecialMethodFilter = "noComment";
export const SMF_Comment: SpecialMethodFilter = "comment";
export const SMF_NoRuleComment = "noRuleComment";
export const SMF_RuleComment = "ruleComment";

//////////
// source: info_security_components.go

export type InfoSecCore = string;
export const Confidentiality: InfoSecCore = "confidentiality";
export const Integrity: InfoSecCore = "integrity";
export const Availability: InfoSecCore = "availability";

//////////
// source: permission.go

export type Permission = string;
export const PermBPAdd: Permission = "BP_Add";
export const PermOwnBPRead: Permission = "Own_BP_Read";
export const PermOwnBPWrite = "Own_BP_Write";
export const PermOwnBPDelete = "Own_BP_Delete";
export const PermAllBPRead = "All_BP_Read";
export const PermAllBPWrite = "All_BP_Write";
export const PermAllBPDelete = "All_BP_Delete";
export const PermAssetAdd = "Asset_Add";
export const PermOwnAssetRead = "Own_Asset_Read";
export const PermOwnAssetWrite = "Own_Asset_Write";
export const PermOwnAssetDelete = "Own_Asset_Delete";
export const PermAllAssetRead = "All_Asset_Read";
export const PermAllAssetWrite = "All_Asset_Write";
export const PermAllAssetDelete = "All_Asset_Delete";
export const PermDataAssetAdd = "DataAsset_Add";
export const PermOwnDataAssetRead = "Own_DataAsset_Read";
export const PermOwnDataAssetWrite = "Own_DataAsset_Write";
export const PermOwnDataAssetDelete = "Own_DataAsset_Delete";
export const PermAllDataAssetRead = "All_DataAsset_Read";
export const PermAllDataAssetWrite = "All_DataAsset_Write";
export const PermAllDataAssetDelete = "All_DataAsset_Delete";
export const PermOwnMeasureRead = "Own_Measure_Read";
export const PermOwnMeasureWrite = "Own_Measure_Write";
export const PermAllMeasureRead = "All_Measure_Read";
export const PermAllMeasureWrite = "All_Measure_Write";
export const PermModuleAdd = "Module_Add";
export const PermOwnModuleRead = "Own_Module_Read";
export const PermOwnModuleWrite = "Own_Module_Write";
export const PermOwnModuleDelete = "Own_Module_Delete";
export const PermAllModuleRead = "All_Module_Read";
export const PermAllModuleWrite = "All_Module_Write";
export const PermAllModuleDelete = "All_Module_Delete";
export const PermOwnJiraExport = "Own_Jira_Export";
export const PermOwnJiraRead = "Own_Jira_Read";
export const PermOwnJiraDelete = "Own_Jira_Delete";
export const PermAllJiraExport = "All_Jira_Export";
export const PermAllJiraRead = "All_Jira_Read";
export const PermAllJiraDelete = "All_Jira_Delete";
export const PermAuditRead = "Audit_Read";
export const PermInternalAudit = "Audit_Internal";
export const PermBasicAudit = "Audit_Basic";
export const PermAdminInstances = "Admin_Instances";
export const PermAdminUsers = "Admin_Users";
export const PermAdminRoles = "Admin_Roles";
export const PermAdminJira = "Admin_Jira";
export const PermAdminSecurityNeed = "Admin_SecurityNeed";
export const PermAdminStandardUpgrade = "Admin_StandardUpgrade";
export const PermAdminCustomFields = "Admin_CustomFields";
export const PermAdminMeasureImport = "Admin_MeasureImport";
export const PermAdminBackup = "Admin_Backup";
export const PermOwnRiskRead = "Own_Risk_Read";
export const PermOwnRiskWrite = "Own_Risk_Write";
export const PermAllRiskRead = "All_Risk_Read";
export const PermAllRiskWrite = "All_Risk_Write";
export const PermOwnRiskDelete = "Own_Risk_Delete";
export const PermAllRiskDelete = "All_Risk_Delete";
export const PermRiskAdd = "Risk_Add";
export const PermAdminRiskSettings = "Admin_Risk_Settings";
export const PermDocumentAdd = "Document_Add";
export const PermDocumentRead = "Document_Read";
export const PermDocumentWrite = "Document_Write";
export const PermDocumentDelete = "Document_Delete";

//////////
// source: priority.go

export type Priority = string;
export const HighPriority: Priority = "high";
export const MediumPriority: Priority = "medium";
export const LowPriority: Priority = "low";

//////////
// source: reference.go

export type ReferenceType = string;
export const MethodReference: ReferenceType = "standard_method_meta_data";
export const CustomMethod: ReferenceType = "method";
export const BusinessProcessReference: ReferenceType = "business_processes";
export const AssetReference: ReferenceType = "assets";
export const DataAssetReference: ReferenceType = "data_assets";
export const ModuleReference: ReferenceType = "module_meta";
export const RiskReference: ReferenceType = "risk_meta";
export const ThreatReference: ReferenceType = "threat_meta";
export const VulnerabilityReference: ReferenceType = "vulnerability_meta";

//////////
// source: risk.go

export type RiskTreatment = string;
export const RT_Unscored: RiskTreatment = "unscored";
export const RT_Preserve: RiskTreatment = "preserve";
export const RT_Share = "share";
export const RT_Reduce = "reduce";
export const RT_Avoid = "avoid";
export const RT_Exclude = "exclude";
export type RiskImportantChange = string;
export const RIC_Added: RiskImportantChange = "added";
export const RIC_TreatmentChanged: RiskImportantChange = "treatmentChanged";
export type RiskEventType = string;
export const RET_AcceptableResidualAchieved: RiskEventType = "acceptableResidualAchieved";

//////////
// source: status.go

export type RuleStatus = number /* int */;
export const RuleNotImplemented: RuleStatus = 0;
export const RuleImplemented: RuleStatus = 1;
export const RuleWillNotImplement: RuleStatus = 2;
export const RuleNeedsAttention: RuleStatus = 3;
export const RuleWillNotApply: RuleStatus = 4;
export const RuleConditionallyImplemented: RuleStatus = 5;
export type MethodStatus = string;
export const NotImplemented: MethodStatus = "Not implemented";
export const PartiallyImplemented: MethodStatus = "Partially implemented";
export const Implemented: MethodStatus = "Implemented";
export const ConditionallyImplemented: MethodStatus = "Conditionally implemented";
export const WillNotImplement: MethodStatus = "Will not implement";
export const WillNotApply: MethodStatus = "Will not apply";
export const NeedsAttention: MethodStatus = "Needs attention";

//////////
// source: tag.go

export type TagType = string;
export const TagModule: TagType = "module";
export const TagBP: TagType = "businessProcess";
export const TagAsset: TagType = "asset";

//////////
// source: type.go

export type Type = string;
export const MainType: Type = "main";
export const StandardType: Type = "standard";
export const HighType: Type = "high";
